import React, { useEffect, useState } from "react";
import "./Verified.css";
import { useNavigate } from "react-router-dom";

function Verified() {
  const navigate = useNavigate();

  const handleBack = () => {
   navigate("/")
  };

  const [isAdv, setIsAdv] = useState(false);

 

  return (
    <div className="success-page">
      <div className="container success-page-container">
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <img src="/img/success-image.svg" className="img-fluid" alt="" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center mt-4">
            <h2 className="success-heading">Verified</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <p className="success-span">
          
                <>
                  Your account is verified Successfully! Now You can login to your account.
                </>
           
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <button onClick={handleBack} className="btn agent-register-button">
              Back to DDH
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Verified;
